import { render, staticRenderFns } from "./MailMagazineCheckItem.vue?vue&type=template&id=2daeb266&scoped=true&"
import script from "./MailMagazineCheckItem.vue?vue&type=script&lang=ts&"
export * from "./MailMagazineCheckItem.vue?vue&type=script&lang=ts&"
import style0 from "./MailMagazineCheckItem.vue?vue&type=style&index=0&id=2daeb266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daeb266",
  null
  
)

export default component.exports